import { render, staticRenderFns } from "./LivesScheduled.vue?vue&type=template&id=b7f24808"
import script from "./LivesScheduled.vue?vue&type=script&lang=js"
export * from "./LivesScheduled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports